import { IPublicClientApplication } from '@azure/msal-browser';
import { dvList, dvCreate, dvUpdate, dvDelete } from '../api/dataverseClient';
import { ProjectLibrary } from '../types';

const FIELDS = [
  'dagrun_pm_projectlibraryid', 'dagrun_pm_name',
  'dagrun_pm_siteid', 'dagrun_pm_driveid', 'dagrun_pm_siteurl',
  'dagrun_pm_displayorder', '_dagrun_pm_projectid_value',
];

export async function getProjectLibraries(pca: IPublicClientApplication, projectId: string): Promise<ProjectLibrary[]> {
  return dvList<ProjectLibrary>(pca, 'dagrun_pm_projectlibraries', {
    select: FIELDS,
    filter: `_dagrun_pm_projectid_value eq ${projectId}`,
    orderby: 'dagrun_pm_displayorder asc,dagrun_pm_name asc',
    top: 200,
  });
}

export interface CreateLibraryInput {
  projectId: string;
  name: string;
  siteId: string;
  driveId: string;
  siteUrl: string;
  displayOrder: number;
}

export async function createProjectLibrary(pca: IPublicClientApplication, input: CreateLibraryInput): Promise<string> {
  return dvCreate(pca, 'dagrun_pm_projectlibraries', {
    dagrun_pm_name: input.name,
    dagrun_pm_siteid: input.siteId,
    dagrun_pm_driveid: input.driveId,
    dagrun_pm_siteurl: input.siteUrl,
    dagrun_pm_displayorder: input.displayOrder,
    'dagrun_pm_projectid@odata.bind': `/dagrun_pm_projects(${input.projectId})`,
  });
}

export async function updateProjectLibraryOrder(pca: IPublicClientApplication, id: string, displayOrder: number): Promise<void> {
  return dvUpdate(pca, 'dagrun_pm_projectlibraries', id, { dagrun_pm_displayorder: displayOrder });
}

export async function deleteProjectLibrary(pca: IPublicClientApplication, id: string): Promise<void> {
  return dvDelete(pca, 'dagrun_pm_projectlibraries', id);
}

export function nextLibraryOrder(libraries: ProjectLibrary[]): number {
  return libraries.reduce((m, l) => Math.max(m, l.dagrun_pm_displayorder ?? 0), 0) + 1;
}
